import { render, staticRenderFns } from "./ListRuns.vue?vue&type=template&id=1835e1e0&scoped=true&"
import script from "./ListRuns.vue?vue&type=script&lang=js&"
export * from "./ListRuns.vue?vue&type=script&lang=js&"
import style0 from "./ListRuns.vue?vue&type=style&index=0&id=1835e1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1835e1e0",
  null
  
)

export default component.exports